import { useSelector } from "react-redux";
import { setApproverTab } from "../../state/slices/generalSlice";
import ApproveTRLocal from "./ApproveTRLocal";
import ApproveCos from "./ApproveCos";
import ApproveCwa from "./ApproveCwa";
import ApproveFsr from "./ApproveFsr";

import { CarFilled, CarryOutOutlined, FileDoneOutlined, FileTextOutlined } from "@ant-design/icons";
import TabSelection from "../../components/SelectContent/TabSelection";
import { mapUnitToAcronym, FACULTY_UNIT_ACRONYMS } from "../../utils/ouberUtils";
import { isProgramChairPositionName } from "../../utils/generalUtils";

const ApproverPage = () => {
  const { positions } = useSelector((state) => state.accountDetailSlice.details);
  const hasFacultyApproverPosition = (positions || []).some(
    (p) => p?.is_approver && FACULTY_UNIT_ACRONYMS.includes(mapUnitToAcronym(p?.unit))
  );
  // TR/COS/CWA are Dean-level (or non-faculty approver) territory — a person
  // whose only approver position is Program Chair shouldn't see these tabs
  // at all. Holding a Dean position too (or any other approver position,
  // e.g. an ICTDO office role) still unlocks them.
  const hasNonChairApproverPosition = (positions || []).some(
    (p) => p?.is_approver && !isProgramChairPositionName(p?.position_name)
  );

  const menuItems = [
    ...(hasNonChairApproverPosition ? [{
      key: "tr-local",
      label: "Local Travel Request",
      abbre: "TR",
      component: <ApproveTRLocal />,
      icon: <CarFilled />,
    }] : []),
    ...(hasNonChairApproverPosition ? [{
      key: "cos",
      label: "Certificate of Service",
      abbre: "COS",
      component: <ApproveCos />,
      icon: <CarryOutOutlined />,
    }] : []),
    ...(hasNonChairApproverPosition ? [{
      key: "cwa",
      label: "Certificate of Work Accomplishment",
      abbre: "CWA",
      component: <ApproveCwa />,
      icon: <FileDoneOutlined />,
    }] : []),
    ...(hasFacultyApproverPosition ? [{
      key: "fsr",
      label: "Faculty Service Record",
      abbre: "FSR",
      component: <ApproveFsr />,
      icon: <FileTextOutlined />,
    }] : []),
  ];

  return (
    <>
      <TabSelection
        menuItems={menuItems}
        currentTabKey="approverCurrentTab"
        setTabAction={setApproverTab}
      />
    </>
  );
};

export default ApproverPage;
